'use client';

import AreaContextType from '@/enums/AreaContextType';
import { createContext } from 'react';

export const AreaContext = createContext<AreaContextType>(AreaContextType.DEFAULT);

export default function AreaProvider({ children, areaType }: { children: React.ReactNode; areaType: AreaContextType }) {
	return <AreaContext.Provider value={areaType}>{children}</AreaContext.Provider>;
}
